import { AnyAction } from 'redux';
import { PaginatedResponse } from '@synergy/api';
import { Topic, TopicListItem } from '@synergy/models';

import {
    AVAILABLE_TOPICS_FOR_CUSTOMER_RECEIVED,
    AVAILABLE_TOPICS_FOR_CUSTOMER_REQUEST,
    TOPICS_FAILED,
    TOPICS_RECEIVED,
    TOPICS_REQUEST,
    TOPIC_DELETED,
    TOPIC_DETAIL_CLEAR,
    TOPIC_DETAIL_RECEIVED,
} from './topics-actions';

export interface TopicsReducerState {
    topics: PaginatedResponse<TopicListItem>;
    detail: Topic | null;
    requesting: boolean;
}

export const initialTopicsReducerState: TopicsReducerState = {
    topics: { items: [], limit: 0, page: 0, total: 0 },
    detail: null,
    requesting: false,
};

export const topicsReducer = (
    state: TopicsReducerState = initialTopicsReducerState,
    action: AnyAction
): TopicsReducerState => {
    const { type } = action;

    switch (type) {
        case AVAILABLE_TOPICS_FOR_CUSTOMER_REQUEST:
        case TOPICS_REQUEST: {
            return {
                ...state,
                requesting: true,
            };
        }

        case TOPICS_RECEIVED: {
            return {
                ...state,
                topics: action['topics'],
                requesting: false,
            };
        }

        case AVAILABLE_TOPICS_FOR_CUSTOMER_RECEIVED: {
            return {
                ...state,
                topics: {
                    ...initialTopicsReducerState.topics,
                    items: action['topics'],
                },
                requesting: false,
            };
        }

        case TOPIC_DETAIL_RECEIVED: {
            return {
                ...state,
                detail: action['topic'],
            };
        }

        case TOPIC_DETAIL_CLEAR: {
            return {
                ...state,
                detail: null,
            };
        }

        case TOPIC_DELETED: {
            return {
                ...state,
                topics: {
                    ...state.topics,
                    items: state.topics.items.filter((topic: TopicListItem) => topic.id !== action['topicId']),
                    total: state.topics.total - 1,
                },
            };
        }

        case TOPICS_FAILED: {
            return {
                ...state,
                requesting: false,
            };
        }

        default: {
            return state;
        }
    }
};
